import styled from '@emotion/styled'

import { colors } from 'component-library/__styling/settings'
import { calcEm, calcRem } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'
import { TextItem } from 'component-library/typography/TextItem/TextItem'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledSubhead = styled(TextItem)(
    {
        ...breakWords,
        fontWeight: 700 as 700,
        lineHeight: 1,
        clear: 'both',
    },
    ({ theme }) => ({
        fontFamily: theme.fonts.subheading,

        fontSize: themedValue(theme, {
            thewest: calcRem(18),
            perthnow: calcRem(22),
            sevennews: calcRem(26),
        }),
        color: themedValue(theme, {
            thewest: colors.thewest.greyGorilla,
            perthnow: colors.perthnow.greyCoal,
            sevennews: undefined,
        }),
        textTransform: themedValue(theme, {
            thewest: 'none' as 'none',
            perthnow: 'uppercase' as 'uppercase',
            sevennews: undefined,
        }),
        marginTop: themedValue(theme, {
            thewest: calcRem(32),
            perthnow: undefined,
            sevennews: undefined,
        }),
        marginBottom: themedValue(theme, {
            thewest: undefined,
            perthnow: calcEm(5),
            sevennews: undefined,
        }),
    })
)
